export const isNumber = value => {
  return !isNaN(parseFloat(value));
};

export const roundFloat = num => parseFloat(num.toFixed(3));

export const ftToRoundedInches = num => {
  return roundFloat(num * 12.0);
};



// WEBPACK FOOTER //
// ./src/utils/numbers.js